import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import {
  ModalService,
  ReactiveComponent,
  TwoButtonModalV2Component,
  PagesV2Module,
} from '@schenck/rotec-components';
import { Observable, takeUntil } from 'rxjs';
import { routes } from 'src/routes';
import { ABORT_CREATION_MODAL_DATA, ABORT_EDIT_MODAL_DATA } from 'src/utils/constants/modal.const';
import { RotorTypeListState } from './rotor-type-list/store/rotor-type-list.reducers';
import { noOfRotorTypes } from './rotor-type-list/store/rotor-type-list.selectors';
import { TranslateDirective } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';

/**
 * Navigation component.
 */
@Component({
  selector: 'rm-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.less'],
  imports: [PagesV2Module, TranslateDirective, AsyncPipe],
})
export class PagesComponent extends ReactiveComponent {
  private readonly store = inject<Store<RotorTypeListState>>(Store);
  private readonly modalService = inject(ModalService);
  private readonly router = inject(Router);

  public rotorTypeListUrl = routes.rotorTypeList.absoluteUrl;

  public noOfRotorTypes$: Observable<number> = this.store.pipe(select(noOfRotorTypes));

  public get isActive(): boolean {
    return this.router?.url === this.rotorTypeListUrl;
  }

  public get isEditMode(): boolean {
    return this.router?.url.includes('edit');
  }

  constructor() {
    super();
  }

  public returnToList(): void {
    if (this.router.url !== this.rotorTypeListUrl) {
      const modalData = this.isEditMode ? ABORT_EDIT_MODAL_DATA : ABORT_CREATION_MODAL_DATA;
      const modal = this.modalService.open(TwoButtonModalV2Component, modalData);

      modal.events$.pipe(takeUntil(this.onDestroy$)).subscribe((result) => {
        if (result) {
          this.router.navigateByUrl(this.rotorTypeListUrl);
        }
      });
    }
  }
}
